import { useState, useLayoutEffect } from "react";
import TreeAPI from "../apis/TreeAPI";

const useLessonDetails = (id) => {
  const [details, setDetails] = useState(undefined);

  useLayoutEffect(() => {
    if (!id) return;
    setDetails(undefined);
    const unsubscribe = TreeAPI.subscribeToLessonDetails(
      id,
      (key, value) => setDetails((state) => ({ ...state, [key]: value })),
      (key) => setDetails((state) => ({ ...state, [key]: undefined }))
    );
    return () => unsubscribe();
  }, [id]);

  return details;
};

export { useLessonDetails };
